import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'

// actions
export const SELECT_ITEM = 'menu/SELECT_ITEM'

export const MenuActions = {
  selectItem: (selected: string) => createAction(SELECT_ITEM, selected)
}

export type MenuActions = ActionsUnion<typeof MenuActions>
